<template>
  <div 
    class="phone-container">
    <img src="../../assets/images/iphonex-rockies.png">
    <div 
      id="screen_div"
      class="screen"
      @click="hideMenu">
      <div 
        id="menu_div"
        class="phone-menus">
        <div class="mlb-header">
          <img 
            src="../../assets/images/mlb_logo.svg" 
            class="mlb-logo">
          <span class="mlb-text">MLB</span>
        </div>
        <div
          class="phone-card">
          <div 
            v-for="item in config.main"
            :key="item.id">
            <span  
              v-if="showMenuItem(item)"
              class="item-text ml-2 mt-2">
              {{ item.name }}
            </span>
          </div>
          <div class="mt-2 line" />
          <div 
            v-for="section in config.more"
            :key="section.id"
            class="mt-2">
            <span class="section-text ml-2">{{ section.title }}</span>
            <div
              v-for="menu in section.menus"
              :key="menu.id">
              <span
                v-if="showMenuItem(menu)"
                class="item-text ml-2 mt-2">
                {{ menu.name }}
              </span>
            </div>
            <div class="mt-2 line" />
          </div>
        </div>
      </div>
    </div>
    <div 
      class="hamburger" 
      @click="showMenu" />
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      required: true,
    },
    platform: {
      type: String,
      required: true,
    },
    device: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    show: true,
  }),
  async updated() {
    this.showMenu()
  },
  methods: {
    showMenu() {
      document.getElementById('menu_div').style.transition = 'left 0.5s'
      document.getElementById('menu_div').style.left = "0px"
      document.getElementById('screen_div').style.transition = 'background-color 0.5s'
      document.getElementById('screen_div').style.backgroundColor = "rgba(128,128,128,0.5)"
      this.show = true
    },
    hideMenu() {
      document.getElementById('menu_div').style.transition = 'left 0.5s'
      document.getElementById('menu_div').style.left = "-180px"
      document.getElementById('screen_div').style.transition = 'background-color 0.5s'
      document.getElementById('screen_div').style.backgroundColor = "rgba(128,128,128,0.0)"
      this.show = false
    },
    showMenuItem(menuItem) {
      const isActivePlatform = this.platform === 'unfiltered' || (this.platform === 'ios' ? menuItem.ios : menuItem.android)
      const isActiveDevice = this.device === 'unfiltered' || (((device) => menuItem[device])(this.device))
      return isActiveDevice && isActivePlatform
    },
  },
}
</script>

<style scoped>
img {
  max-width: 100%;
  max-height: auto;
}
.phone-container {
  height: 100%;
  width: 100%;
}
.hamburger {
  position: absolute;
  width: 35px;
  height: 35px;
  left: 40px;
  top: 55px;
}
.screen {
  position: absolute;
  left: 37px;
  top: 50px;
  right: 37px;
  height: 540px;
  overflow: hidden;
  background-color: rgba(128,128,128,0.0);
}
.phone-menus {
  position: absolute;
  background-color: white;
  left: -180px;
  top: 0px;
  bottom: 0px;
}
.phone-card {
  height: 90%;
  padding-right: 7px;
  overflow: scroll;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
/* Hide scrollbar for Chrome, Safari and Opera */
.phone-card::-webkit-scrollbar {
  display: none;
}
.mlb-header {
  margin-left: 0px;
  margin-right: 0px;
  background-color: rgba(4, 30, 66);
  height: 46px;
  line-height: 46px;
}
.mlb-logo {
  margin-left: 5px;
  margin-bottom: 5px;
  height: 20px;
}
.mlb-text {
  color: white;
  padding-top: 15px;
  margin-left: 2px;
  font-size: 18px;
  font-weight: bold;
}
.line {
  border: solid 1px #dadada;
}
.item-text {
  font-size: 14px;
}
.section-text {
  font-size: 12px;
}
</style>